import React, { useEffect, useState } from "react";

import { t } from "i18next";

import { Planet } from "../icons/Planet";
import { Signal } from "../icons/Signal";

import styles from "./LiveCountdown.module.css";

const formatTimeToStart = (remainingTime: number) => {
  if (remainingTime <= 0) {
    return t("player.countdown.startSoon");
  }
  const secondsInADay = 86400;
  const secondsInAnHour = 3600;
  const secondsInAMinute = 60;

  const days = Math.floor(remainingTime / secondsInADay);
  const remainingSecondsAfterDays = remainingTime % secondsInADay;
  const hours = Math.floor(remainingSecondsAfterDays / secondsInAnHour);
  const remainingSecondsAfterHours =
    remainingSecondsAfterDays % secondsInAnHour;
  const minutes = Math.floor(remainingSecondsAfterHours / secondsInAMinute);
  const secs = Math.floor(remainingSecondsAfterHours % secondsInAMinute);

  return t("player.countdown", {
    day: days,
    hour: hours,
    minute: minutes,
    sec: secs,
  });
};

interface ICountdown {
  timeToStart: number;
  cover?: string;
}

export const LiveCountdown = ({ timeToStart, cover }: ICountdown) => {
  const [remainingTime, setRemainignTime] = useState<number>(0);

  useEffect(() => {
    setRemainignTime(timeToStart);
    const interval = setInterval(() => {
      setRemainignTime((prevRemainingTime) => prevRemainingTime - 1);
    }, 1000);

    return () => clearInterval(interval);
  }, [timeToStart]);

  return (
    <div
      className={styles.container}
      style={{ backgroundImage: `url(${cover})` ?? "" }}
    >
      {!cover && <Planet />}
      <div className={styles.timeToStartContainer}>
        <Signal />
        <span className={styles.typographyCountdown}>
          {formatTimeToStart(remainingTime)}
        </span>
      </div>
    </div>
  );
};
